<div class="pos-diagnostics-session">
  <nb-card class="mb-4">
    <nb-card-body>
      <div class="row align-items-end g-3">
        <div class="col-md-8">
          <label class="form-label">Diagnostic session ID</label>
          <input type="text" class="form-control font-monospace"
            [(ngModel)]="sessionId"
            placeholder="uuid v4 — one per kiosk app load"
            (keyup.enter)="loadSession()">
        </div>
        <div class="col-md-4">
          <button class="btn btn-primary w-100" [disabled]="!sessionId?.trim() || isLoading" (click)="loadSession()">
            <nb-icon icon="search-outline"></nb-icon>
            Load timeline
          </button>
        </div>
      </div>
      <p class="text-muted small mb-0 mt-2">
        Read a failure as a journey: what the operator did, what the app did, where it went wrong.
        Open a session from the Events list or paste a session ID here.
      </p>
    </nb-card-body>
  </nb-card>

  <div *ngIf="endpointUnavailable" class="alert alert-info d-flex align-items-start gap-2 mb-4">
    <nb-icon icon="info-outline"></nb-icon>
    <div>
      <strong>Backend not ready</strong>
      <p class="mb-0 small">{{ errorMessage }}</p>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center p-5">
    <nb-spinner size="large"></nb-spinner>
    <p class="mt-2 text-muted">Loading session timeline…</p>
  </div>

  <div *ngIf="!isLoading && errorMessage && !endpointUnavailable" class="text-center p-4">
    <nb-icon icon="alert-circle-outline" class="text-danger" style="font-size: 2rem;"></nb-icon>
    <p class="mt-2 text-danger">{{ errorMessage }}</p>
  </div>

  <div *ngIf="!isLoading && !errorMessage && sessionId && events.length === 0" class="text-center p-4">
    <h5>No events in this session</h5>
    <p class="text-muted">The session ID may be invalid, expired (30-day retention), or has no recorded events.</p>
  </div>

  <div *ngIf="!isLoading && events.length > 0">
    <div class="session-summary mb-4" *ngIf="sessionMeta">
      <div class="summary-item" *ngIf="sessionMeta.diagnosticSessionId || sessionId">
        <span class="label">Session</span>
        <code>{{ sessionMeta.diagnosticSessionId || sessionId }}</code>
      </div>
      <div class="summary-item" *ngIf="sessionMeta.terminalId || events[0]?.context?.terminalId">
        <span class="label">Terminal</span>
        <code>{{ sessionMeta.terminalId || events[0]?.context?.terminalId }}</code>
      </div>
      <div class="summary-item" *ngIf="sessionMeta.buildCommit || events[0]?.context?.commit">
        <span class="label">Build</span>
        <code>{{ sessionMeta.buildCommit || events[0]?.context?.commit }}</code>
      </div>
      <div class="summary-item">
        <span class="label">Events</span>
        <strong>{{ events.length }}</strong>
      </div>
      <div class="summary-item" *ngIf="hasErrors()">
        <span class="badge bg-danger">Contains errors</span>
      </div>
    </div>

    <div class="timeline">
      <div *ngFor="let event of events; trackBy: trackByEventId; let last = last"
        class="timeline-item"
        [class.timeline-error]="isErrorEvent(event) && !isCriticalFinancialEvent(event)"
        [class.timeline-critical]="isCriticalFinancialEvent(event)"
        [class.timeline-last]="last">
        <div class="timeline-marker">
          <nb-icon [icon]="isCriticalFinancialEvent(event) ? 'credit-card-outline' : (isErrorEvent(event) ? 'alert-triangle-outline' : 'radio-button-on-outline')"></nb-icon>
        </div>
        <div class="timeline-card">
          <div class="timeline-header">
            <span class="timeline-time">{{ (event.occurredAt || event.createdAt) | date:'HH:mm:ss.SSS' }}</span>
            <span class="badge ms-2" [ngClass]="getLevelBadgeClass(event.level)">{{ event.level }}</span>
            <span class="badge ms-1" [ngClass]="getEventTypeBadgeClass(event.eventType)">
              {{ getEventTypeLabel(event.eventType) }}
            </span>
            <span class="text-muted small ms-2" *ngIf="event.operation">{{ event.operation }}</span>
          </div>
          <p class="timeline-message mb-2">{{ event.message }}</p>

          <div class="timeline-meta small text-muted" *ngIf="event.context?.route">
            Route: <code>{{ event.context.route }}</code>
          </div>

          <div class="timeline-breadcrumbs mt-2" *ngIf="event.breadcrumbs?.length">
            <div *ngFor="let crumb of event.breadcrumbs" class="mini-crumb">
              <nb-icon [icon]="getBreadcrumbIcon(crumb.kind)" class="me-1"></nb-icon>
              <span class="badge bg-light text-dark border">{{ crumb.kind }}</span>
              <span class="ms-1">{{ crumb.detail }}</span>
            </div>
          </div>

          <div class="timeline-cart mt-2" *ngIf="event.context?.cartSnapshot as cart">
            <span class="badge bg-warning text-dark">
              Cart: {{ cart.items }} items · {{ cart.total | number:'1.2-2' }} DKK
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
